/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Spin, Tag } from "antd";
import { ChevronLeft, Bus, Settings } from "lucide-react";

import useBuses from "../hooks/useBuses";
import usePassengers from "../hooks/usePassengers";
import useExcursions from "../hooks/useExcursions";

import ExcursionBusesExpandable from "../components/ExcursionBusesExpandable";
import ExcursionBusesFormModal from "../components/ExcursionBusesFormModal";

function ExcursionBusDetail() {
  const { excursionId, busId } = useParams();
  const navigate = useNavigate();

  const { getBusDetail } = useBuses();
  const { passengers, getPassengers } = usePassengers();
  const { getExcursionDetail, excursionDetail } = useExcursions();

  const [bus, setBus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  useEffect(() => {
    if (!excursionId || !busId) return;

    const loadData = async () => {
      setLoading(true);
      await Promise.all([
        getExcursionDetail(excursionId),
        getBusDetail(busId).then(setBus),
        getPassengers({ scheduled_excursion_bus__id: busId }),
      ]);
      setLoading(false);
    };

    loadData();
  }, [excursionId, busId]);

  const handleUpdateBus = async () => {
    const updatedBus = await getBusDetail(busId);
    setBus(updatedBus);
  };

  if (loading || !bus || !excursionDetail) {
    return <Spin fullscreen />;
  }

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <Button
          type="text"
          onClick={() => navigate(-1)}
          icon={<ChevronLeft size={16} />}
        >
          Volver
        </Button>

        <div className="flex items-center gap-2">
          <Bus size={20} />
          <span className="font-semibold text-lg">
            {bus?.busExcursion?.bus?.busSelectorName}
          </span>
          <Tag color="blue">{bus?.availableSeats} asientos libres</Tag>
        </div>

        <Button
          type="default"
          icon={<Settings size={16} />}
          onClick={() => setIsConfigModalOpen(true)}
        >
          Configurar
        </Button>
      </div>

      <ExcursionBusesExpandable
        record={bus}
        selectedBus={bus}
        selectedExcursion={excursionDetail}
        initialPassengers={passengers}
        updateBus={handleUpdateBus}
      />

      <ExcursionBusesFormModal
        isOpen={isConfigModalOpen}
        onClose={() => {
          setIsConfigModalOpen(false);
          handleUpdateBus();
        }}
        selectedExcursion={excursionDetail}
        selectedBus={bus}
        busToEdit={bus}
      />
    </div>
  );
}

export default ExcursionBusDetail;
